<template>
    <div class="loader">
        <img src="@/assets/img/logo.png" alt="Incroyable Grévin Paris">
    </div>
</template>

<script>
import gsap from "gsap"

export default {
    name: 'Loader',
    mounted() {
        let loaderTL = gsap.timeline({pause: false})

        // loaderTL.addLabel('start')
        // loaderTL.from('.loader .loader-count, .loader .loader-four', {opacity: 0, duration: .75}, 'start+=1')

        loaderTL.addLabel('zoom')
        loaderTL.to('.loader', {scale: 4, opacity: 0, duration: .75}, 'zoom+=1')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.loader {
    position: fixed;
    inset: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: var(--white);

    pointer-events: none;

    img {
        max-width: 450px;
    }

    @media screen and (max-width: 576px) {
        padding: 0 20px;

        img {
            max-width: 100%;
        }
    }
}
</style>
